'use strict';

/* eslint no-undef: "off" */
/**
 * static helper main
 */
define('staticHelperMain',['jquery', 'busEvent', 'headerNavbar', 'util'], function ($, busEvent, headerNavbar, Util) {
  return {
    template: '\n      <div class="main-container in-container">\n        <div class="in-static-page-header">{{title}}</div>\n        <div class="in-static-page-content">\n          <div class="in-static-box" v-html="content"></div>\n        </div>\n      </div>\n    ',
    data: function data() {
      return {
        title: '',
        content: '',
        i18n: {
          postDetail: 'Post Detail'
        }
      };
    },

    components: {
      headerNavbar: headerNavbar
    },
    mounted: function mounted() {
      var _this = this;

      this.init();
      this.$nextTick(function () {
        _this.processNav();
      });
    },

    methods: {
      init: function init() {
        this.title = window.staticPageDataJSON.data.title;
        this.content = window.staticPageDataJSON.data.content;
      },
      processNav: function processNav() {
        var box = $('.staticTop ul');
        try {
          var activeLeft = box.find('li.active').offset().left;
          box.animate({
            scrollLeft: activeLeft
          }, 300);
        } catch (err) {
          console.log(err);
        }
      }
    }
  };
});
